import { withReadyAyManager } from '../../utils/consent/adReadiness'
import {
  whenAyReady,
  withAyManager,
} from '../../utils/ad-ops/assertive-yield/queue'

export type AssertiveYieldPageViewType = 'initial' | 'navigation'
let cancelPendingNavigation = () => {}

export function syncAssertiveYieldPageView(
  type: AssertiveYieldPageViewType
): void {
  if (!import.meta.client || type === 'initial') return
  whenAyReady(() => window.assertive?.nextPage?.())
  cancelPendingNavigation()
  cancelPendingNavigation = withReadyAyManager(withAyManager, () =>
    window.ayManagerEnv?.changePage()
  )
}
